import React, { useContext } from 'react';
import { DataContext } from '../../utils/context';
const ContextConsumer = (props) => {
    const { valueFor, children, name } = props;
    const getNestedObjectValue = (obj, attr) => {
        if (obj === undefined)
            return undefined;
        let res;
        let curObj = obj;
        const attrArr = attr?.split('.') ?? [];
        for (const item of attrArr) {
            res = curObj[item];
            if (res === undefined) {
                return res;
            }
            curObj = res;
        }
        return res;
    };
    const context = useContext(DataContext);
    const value = getNestedObjectValue(context, name);
    return children?.map((child) => React.cloneElement(child, { [valueFor]: value }));
};
export default ContextConsumer;
